// extracted by mini-css-extract-plugin
export var button = "_lp-2";
export var card = "_lp-0";
export var closeButtonContainer = "_lp-3";
export var iconContainer = "_lp-1";